export const validationRules = {
  isNotEmpty: (value: string) => {
    if (value.length) return true;
    return "Please enter a value.";
  },

  hasMinLength: (value: string, minLength: number) => {
    if (value.length > minLength) return true;
    return `Field need to contain more than ${minLength} symbols`;
  },
  isEmail: (value: string) => {
    if (value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) return true;
    return "Email address seems invalid.";
  },
  isChecked: (value: boolean) => {
    if (value) return true;
    return "Please check this box if you want to proceed.";
  },
};
